import type { B2BContactFormType } from '#shared/types/B2B'

/**
 * Composable for B2B functionality
 */
export function useB2B() {
    const { $api } = useNuxtApp()

    /**
     * Sends a B2B contact form
     */
    async function sendContactForm(data: B2BContactFormType): Promise<void> {
        await $api.post(`/b2b-contact-form`, data)
    }

    return {
        sendContactForm
    }
}
